<ng-container *ngIf="schemaInfo">
    <h6 class="text-secondary">Digitale Outputs</h6>
    <div class="row mt-4">

        <mat-slide-toggle class="mb-3" [checked]="digitalOneChecked" [disabled]="!digitalOneFound"
            (change)="onDigitalOutputsToggleValueChange(6, $event.checked)" color="primary" style="display: none;">
            Digital 1 Output
        </mat-slide-toggle>
        <mat-slide-toggle class="mb-3" [checked]="digitalTwoChecked" [disabled]="!digitalTwoFound"
            (change)="onDigitalOutputsToggleValueChange(7, $event.checked)" color="primary" style="display: none;">
            Digital 2 Output
        </mat-slide-toggle>
        <mat-slide-toggle class="mb-3" [checked]="radarChecked" [disabled]="!radarFound"
            (change)="onDigitalOutputsToggleValueChange(8, $event.checked)" color="primary">
            Radar
        </mat-slide-toggle>
        <mat-slide-toggle class="mb-3" [checked]="annaChecked" [disabled]="!annaFound"
            (change)="onDigitalOutputsToggleValueChange(9, $event.checked)" color="primary">
            Anna
        </mat-slide-toggle>

    </div>
    <div *ngIf="schemaInfo.digitalIOs.length === 0" class="text-danger ms-2 ">
        Keine Outputs vorhanden </div>
</ng-container>